// Akıllı API URL tespiti
// Production'da kendi domain'ini kullan, development'ta env variable kullan

const getApiUrl = () => {
  // Tarayıcıda çalışıyorsa
  if (typeof window !== 'undefined') {
    const currentHost = window.location.origin;
    
    // Eğer eskayahsap.online'da çalışıyorsa, kendi domain'ini kullan
    if (currentHost.includes('eskayahsap.online')) {
      return 'https://eskayahsap.online/api';
    }
    
    // Eğer preview ortamındaysa
    if (currentHost.includes('preview.emergentagent.com')) {
      return `${currentHost}/api`;
    }
    
    // Eğer başka bir custom domain'de çalışıyorsa, kendi domain'ini kullan
    if (!currentHost.includes('localhost') && !currentHost.includes('127.0.0.1')) {
      return `${currentHost}/api`;
    }
  }
  
  // Fallback: environment variable
  return `${process.env.REACT_APP_BACKEND_URL}/api`;
};

export const API = getApiUrl();
export default API;
